import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { toggleLoading } from "../../../redux";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {ToastrService} from "ngx-toastr";
import {HttpErrorResponse} from "@angular/common/http";
import {HistoryService} from "../../services";
import {IHistory} from "../../models/i-history";

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {

  @Input() title: string = '';
  @Input() subTitle: string = '';
  @Input() type: string = '';
  @Input() id: string = '';


  expandedElement: IHistory | null = {} as IHistory;
  dataSource: MatTableDataSource<IHistory> = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  public columnsToDisplay = ['propertyName', 'oldValue', 'arrow', 'newValue', 'businessUnit', 'user', 'changedDate'];
  // historyCols = ['propertyName', 'oldValue', 'arrow', 'newValue'];

  // columnsToDisplayWithExpand = [...this.columnsToDisplay, 'expand'];
  // columnsToDisplayWithExpand = [...this.columnsToDisplay];

  data: IHistory[] = [];
  uniquePropertyNames: string[] = [];
  fromDate? : moment.Moment;
  toDate? : moment.Moment;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private toastr: ToastrService,
    private history: HistoryService
  ) {
  }

  ngOnInit(): void {
    this.getParams();
  }

  subscribeToDatasource() {
    console.log("Fetching History...", this.fromDate, this.toDate);
    const fromDateStr = this.fromDate?.format("YYYY-MM-DD") || '';
    const toDateStr = this.toDate?.format("YYYY-MM-DD") || '';
    // console.log(fromDateStr, toDateStr)
    this.store.dispatch(toggleLoading({loading: true}));
    this.history.getHistory(this.type, this.id, fromDateStr, toDateStr).subscribe({
      next: (res: any) => {
        this.data = res;
        this.dataSource = new MatTableDataSource(res);
        this.initDataSource();
        this.getUniquePropertyNamesFromData();
        this.store.dispatch(toggleLoading({loading: false}));
      }, error: (err: HttpErrorResponse) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to get history!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  getParams() {
    let assetType = this.route.snapshot.paramMap.get('assetType');
    let id = this.route.snapshot.queryParamMap.get('id');

    if (!id) {
      this.toastr.error("Id missing");
      return;
    }

    if (!assetType) {
      this.toastr.error("Asset Type missing");
      return;
    }

    this.type = assetType.toString();
    this.title = assetType.toString();
    this.id = id;

    // //TODO the history route for users breaks the pattern due to additional fragment
    // if (assetType == 'users') {
    //   this.type = 'users';
    // }

    this.subscribeToDatasource();
  }

  initDataSource() {
    this.dataSource.filterPredicate = (data: IHistory, filter: string) => {
      return data.name.toLowerCase() == filter.toLowerCase();
    };
    if (!!this.paginator) {
      this.paginator.pageSize = 100;
      this.dataSource.paginator = this.paginator;
    }
    if (!!this.sort) {
      this.dataSource.sort = this.sort;
    }
  }


  private getUniquePropertyNamesFromData() {
    this.data.forEach((d: IHistory) => {
      if (!this.uniquePropertyNames.includes(d.name)) {
        this.uniquePropertyNames.push(d.name);
      }
    });
    this.uniquePropertyNames.sort();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterProp(filterValue);
  }

  filterProp(prop: string) {
    this.dataSource.filter = prop.trim();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // canExpand(element: any): boolean {
  //   return !!element && !!element.changes && element.changes.length > 0;
  // }

  // expandRow(element: any) {
  //   if (this.canExpand(element)) {
  //     this.expandedElement = this.expandedElement === element ? null : element;
  //   }
  // }
}


